<section class="custom-info">
  <img src="../../../../../../assets/report_v2/info-blue.svg" alt="info-blue">
  <section class="info-content">
    <h2>{{ title }}</h2>
    <p>{{ description }}</p>
  </section>
</section>
